module.exports = __webpack_public_path__ + "static/media/emma-roberts-icon.335e2035.jpg";